import PropTypes from 'prop-types';
import React from 'react';

import { CLIENT_ROOT } from 'src/constants/paths';
import useTabs from 'src/hooks/useTabs';

import { athenaUrl } from '../../helpers';
import styles from './VisitsDueView.module.scss';

const OpenButtons = ({ row }) => {
  const { onSelectTab } = useTabs();
  const integration = row.patient?.athenaIntegration;
  const athenaHref = athenaUrl(integration?.athenaPatientId, integration?.practiceId);

  return (
    <div className={styles.openButtons}>
      <button
        type="button"
        className={styles.openButton}
        title="Open in Platform"
        onClick={(event) => {
          event.stopPropagation();
          onSelectTab({ path: `${CLIENT_ROOT}/patients/details/${row.patientId}/info` });
        }}
      >
        M
      </button>
      <a
        className={styles.openButton}
        title="Open in Athena"
        href={athenaHref ?? undefined}
        target={athenaHref ? '_blank' : undefined}
        rel={athenaHref ? 'noopener noreferrer' : undefined}
        aria-disabled={!athenaHref}
        onClick={(event) => event.stopPropagation()}
      >
        A
      </a>
    </div>
  );
};

OpenButtons.propTypes = {
  row: PropTypes.shape({
    patientId: PropTypes.number.isRequired,
    patient: PropTypes.object,
  }).isRequired,
};

export default OpenButtons;
